import dateformat from 'dateformat';

export default function getFormattedDate(date, format) {
  if (!date) {
    return '';
  }
  const dt = typeof date !== 'object' ? new Date(date.replace(/-/g, '/')) : date;
  if (dt) {
    return dateformat(dt, format);
  }
  return '';
}
